import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { urls } from "./editScenarioNewUtils";
import { apiUrls } from "../../../library/Utils";
import dayjs from "dayjs";
import { saveAs } from "file-saver";
import { orderBy } from "lodash";

const initialState = {
	isLoadingEdit: false,
	editModeEdit: true,

	countries: [],
	selectedCountry: "",
	countryID: "",
	scenarioName: "",
	editScenarioList: [],
	editScName: "",
	editScID: "",
	editScDetails: null,
	periodType: "",
	periodTypes: [],
	criticalityList:[],
	criticalityId : "",
	createFromDate: dayjs(),
	createToDate: dayjs("2099-12-31"),
	sentToSAP: false,
	dataSources: [],
	scenarioStatus: "",

	skuCategories: ["All", "Individual SKU", "Product Group"],
	selectedSKUCategory: "All",
	sku_PG_Name: "",
	productGroups: [],
	productGroupsForMS : [],
	selectedPGs: [],
	custsCGs: [],
	selectedCustsCGs: [],

	selectedCTCode: "",
	selectedCLID: "",
	selectedTLID: 0,
	customerName: "",
	activeCustomerOnly: true,
	selectedCCID: "0",

	customerLevels: [],
	customerTypes: [],
	selectedcustomerTypes : [],
	trustLevels: [],
	customerCategories: ["All", "Individual Customer", "Customer Group"],
	selectedCL: "",
	selectedCustType: "",
	selectedTL: "All",
	selectedCustCat: "All",

	selectedDSs: [],
	selectedPDS: [],
	DSAData: [],
	selectedPG_SKU_ADSs: [],
	DSAIdString: "",

	selectedPG_SKU_ADSsID: "",
	scDSA: [],
	scDSACopy : [],
	DSAIdStringPrev: "",

	minimumQuota: "",
	skuBreakdown: "",
	selectedScSTQ: "",
	scenarioSTQ: [],

	DSMHigh: "",
	DSMMed: "",
	DSMLow: "",
	DSMOth: "",
	isCloneDisable : false,
	isCopyDisable : false,
	isButtonDisable : false,
	customerBreakdownType: "Scenario SKUs",
	customerBreakdown: "",
	MarketShareTimePeriod: "",
	PreviousMarketShareTimePeriod: "",
	emailNotification: false,
	//SafetyMargin : [{type: "Customer Group", safetyMargin: '', typeCode: "CustomerGroup"}],
	SafetyMargin: [],
	CBDMType: ["Scenario SKUs", "Reference SKUs", "External","Manually Defined",
	"External Fix","No Breakdown","Dynamic Market Share"],
	CBDMPeriod: [
		"Internal 1 month",
		"Internal 3 months",
		"Internal 6 months",
		"Internal 12 months",
	],
	email: "",

	comments: "",

	primaryDataSourceID: "",

	message: "",
	severity: "",
	messageOpen: false,

    editScDSAData: null,
	predictionMethodPeriodList:[],
	previousYearPeriodList:[],
	selectedLinearTrend: "",
	selectedRunRate: "",
	selectedConsensus: "",
	selectedPreviousYear: "",
	quotaDeviationPercentage : 0,
	modificationDeviationPercentage : 0,
	selectedDefaultInitialForecast : "",
	DefaultInitialForecast : [],
	localForecastAlignment : [],
	midasFilter : [],
	midasFilterParameters : [],
	scenarioExternalDataSource:[],
	scenarioExternalDataSourceSKU:[],
	scenarioExternalDataSource:[],
	scenarioExternalDataSourceSKU:[],
	selectedReferenceSKU:[],
	previousSelectedReferenceSKU:[],
	marketShareComparisonList : [],
	previousMarketShareComparisonList : [],
	selectedRows :[],
	marketShareGraphData : [],
	previousMarketShareGraphData : [],
	manually_defineMSList : [],
	drawerOpen: false,
	refList : '',
	legends : ['Scenario SKU','Reference SKU','External','Manually Defined'],
	openScenarioPopUp: false,
	errorMessage : '',
	errorList : [],
	section_Scenario_Parameteres : false,
	section_SKU : false,
	section_Customer : false,
	section_Datasources : false,
	section_Scenario_Settings : false,
	LocalFilter : [],
	premidasFilterParameters : [],
	preLocalFilterParameterList : [],
	localFilterParameters : [],
	prelocalFilterParameters : [],
	isLoadingAlignment : false,
	isLoadingAlignmentperSKU : false,
	isCustomerChanged : false,
	filteredCustomerTypes : [],
	search_ScenarioName : "",
	search_FromDate : null,
	search_ToDate : null,
	data_after_Submit : null
};

export const getUserCountriesEdit = createAsyncThunk(
	"editScenarioNew/getUserCountries",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const url = urls.countryListUrl + data.userID;
		const response = await fetch(url);
		const jsonData = await response.json();
		return jsonData;
	}
);

export const getDataSources = createAsyncThunk(
	"editScenarioNew/getDataSources",
	async ({ countryID }, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		const options = {
			headers,
		};
		const url = urls.getDataSourcesByCountry + `countryId=${countryID}`;
		const response = await fetch(url, options);
		const jsonData = await response.json();
		return jsonData;
	}
);

export const getScenario = createAsyncThunk(
	"editScenarioNew/getScenario",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const { countryId, scenario, fromDate, toDate } = obj;
		const url =
			urls.getScenario +
			`countryId=${countryId}&scenario=${scenario}&fromDate=${fromDate}&toDate=${toDate}`;
		try {
			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const jsonData = await response.json();
			return jsonData;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);

export const getScenarioDetails = createAsyncThunk(
	"editScenarioNew/getScenarioDetails",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const { scenarioId } = obj;
		const url = urls.scDetails + `scenarioId=${scenarioId}`;
		try {
			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const jsonData = await response.json();
			return jsonData;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);

export const getScDSAData = createAsyncThunk(
	"editScenarioNew/getScDSAData",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const { scenarioId } = obj;
		const url = urls.editScDSAData + `scenarioId=${scenarioId}`;
		try {
			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const jsonData = await response.json();
			return jsonData;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);
export const localForecastDataAlignmentCheck = createAsyncThunk(
	"setup/localForecastDataAlignmentCheck",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const url = urls.localForecastDataAlignmentCheck;
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = await response.json();
			return jsonData;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);
export const getAllEnums = createAsyncThunk(
	"editScenarioNew/getAllEnums",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const url = urls.enums;
		try {
			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const jsonData = await response.json();
			return jsonData;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);

export const getCriticalityList = createAsyncThunk(
	"setup/getCriticalityList",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		const options = {
			headers,
		};
		const url = apiUrls.scenarioCriticalityList;
		const response = await fetch(url, options);
		const jsonData = await response.json();
		return jsonData;
	}
);


export const getProductGroup = createAsyncThunk(
	"editScenarioNew/getProductGroup",
	async ({ countryID, sku_PG_Name }, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		const options = {
			headers,
		};
		const url =
			urls.searchPG + `countryId=${countryID}&productgrp=${sku_PG_Name}`;
		const response = await fetch(url, options);
		const jsonData = await response.json();
		return jsonData;
	}
);

export const getProductGroupForMS = createAsyncThunk(
	"setup/getProductGroupForMS",
	async ({ countryID, search }, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		const options = {
			headers,
		};
		const url =
			urls.searchPG +
			`countryId=${countryID}&productgrp=${search}`;
		const response = await fetch(url, options);
		const jsonData = await response.json();
		return jsonData;
	}
);


export const getCustsAndCGs = createAsyncThunk(
	"editScenarioNew/getCustsAndCGs",
	async (
		{
			obj
		},
		thunkAPI
	) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const url =
			urls.searchCG;
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = await response.json();
			return jsonData;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);

export const getCustGrpRef = createAsyncThunk(
	"setup/getCustGrpRef",
	async ({ countryID }, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		const options = {
			headers,
		};
		const url = urls.CGRefData + `countryId=${countryID}`;
		const response = await fetch(url, options);
		const jsonData = await response.json();
		return jsonData;
	}
);

export const getTrustLevel = createAsyncThunk(
	"editScenarioNew/getTrustLevel",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		const options = {
			headers,
		};
		const url = apiUrls.relationshipLevelUrl;
		const response = await fetch(url, options);
		const jsonData = await response.json();
		return jsonData;
	}
);

export const getDSAData = createAsyncThunk(
	"setup/getDSAData",
	async ({ countryID, idString }, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		const options = {
			headers,
		};
		const url =
			apiUrls.GetDSAData +
			`countryId=${countryID}&dataSourceNames=${idString}`;
		const response = await fetch(url, options);
		const jsonData = await response.json();
		return jsonData;
	}
);

export const getScSTQ = createAsyncThunk(
	"setup/getScSTQ",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		const options = {
			headers,
		};
		const url = apiUrls.stickToQuota;
		const response = await fetch(url, options);
		const jsonData = await response.json();
		return jsonData;
	}
);
export const MidasAlignmentFilter = createAsyncThunk(
	"setup/MidasAlignmentBasedOnFilter",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const url = apiUrls.MIDAS_DataAlignment;
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = await response.json();
			return jsonData;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);
export const exportTemplate_DataEdit = createAsyncThunk(
	"scenario/exportTemplate_Data",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const {
			scenarioId,
			scenarioName,
			countryId,
			countryName,
            customer,
            customerGroup
		} = obj;
		const url = apiUrls.DownLoadTemplate;
		const postBody = {
			scenarioId,
			scenarioName,
			countryId,
			countryName,
            customer,
            customerGroup
		};
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(postBody),
			});
			const res = await response.blob();
			const extension = "xls";
			const fileName = `ExternalBreakdownMethodology.xls`
			saveAs(res, fileName);
			return res;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);
export const exportTemplate_DataSKUEdit = createAsyncThunk(
	"scenario/exportTemplate_DataSKU",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const {
			scenarioId,
			scenarioName,
			countryId,
			countryName,
            product,
            productGroup,
			isSKUBreakdown
		} = obj;
		const url = apiUrls.DownLoadTemplate;
		const postBody = {
			scenarioId,
			scenarioName,
			countryId,
			countryName,
            product,
            productGroup,
			isSKUBreakdown
		};
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(postBody),
			});
			const res = await response.blob();
			const extension = "xls";
			const fileName = `ExternalBreakdownMethodologySKU.xls`
			saveAs(res, fileName);
			return res;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);
export const ImportExcelEdit = createAsyncThunk(
	"scenario/ImportExcelEdit",
	async (obj, thunkAPI) => {
	   const data = JSON.parse(localStorage.getItem("data"));
	   const token = data.token;
	   const {
		scenario,
		recCnt,
		formData
		} = obj;
	   const url = apiUrls.ImportExcel +`scenario=${scenario}&recCount=${recCnt}`;
	   try {
		  const response = await fetch(url, {
			 method: "POST",
			 headers: {
				Authorization: `Bearer ${token}`,
   				Accept: "application/json",
   				"Content-Disposition": "multipart/form-data",

			 },
			 body: formData,
		  });
		  const jsonData = await response.json();
		  return jsonData;
	   } catch (error) {
		  console.error("Error: ", error);
	   }
	}
);
export const ImportExcelSKUEdit = createAsyncThunk(
	"scenario/ImportExcelSKUEdit",
	async (obj, thunkAPI) => {
	   const data = JSON.parse(localStorage.getItem("data"));
	   const token = data.token;
	   const {
		scenario,
		recCnt,
		formData
		} = obj;
	   const url = apiUrls.ImportExcelSKU +`scenario=${scenario}&recCount=${recCnt}`;
	   try {
		  const response = await fetch(url, {
			 method: "POST",
			 headers: {
				Authorization: `Bearer ${token}`,
   				Accept: "application/json",
   				"Content-Disposition": "multipart/form-data",

			 },
			 body: formData,
		  });
		  const jsonData = await response.json();
		  return jsonData;
	   } catch (error) {
		  console.error("Error: ", error);
	   }
	}
);
export const MarketShareComparison = createAsyncThunk(
	"setup/GetMarketShareComparison",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const url = apiUrls.MarketShareComparison;
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = await response.json();
			return jsonData;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);

export const submitScenario = createAsyncThunk(
	"editScenarioNew/submitScenario",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const url = urls.submitScenario;
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = await response.json();
			return jsonData;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);

export const saveScenario = createAsyncThunk(
	"editScenarioNew/saveScenario",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const url = urls.saveScenario;
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = await response.json();
			return jsonData;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);

export const verifyScenario = createAsyncThunk(
	"editScenarioNew/verifyScenario",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const url = urls.verifyScenario;
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = await response.json();
			return jsonData;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);

export const cloneScenario = createAsyncThunk(
	"editScenarioNew/cloneScenario",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const url = urls.cloneScenario;
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = await response.json();
			return jsonData;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);
export const exportFile_Data = createAsyncThunk(
	"analyze/exportFile_Data",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const {
			isPdf,
			scenarioName,
			countryName,
            userid,
            roleName,
            isEdit,
            email,
            displayStickToQuota,
            sentToSAP,
            SentToSAP4PLExport,
            stickToQuota,
            scenarioDatasource,
            customers,
            customerGroups,
            product,
            productGroup,
            criticalityId ,
            scenarioStatus,
            effectiveStartDate,
            effectiveEndDate,
            updatedBy,
			updatedDate,
			countryID,
			customerBreakdown ,
			customerBreakdownType,
			skuBreakdown,
			defaultInitialForecast,
			emailNotification,
			financialFCTimePeriod,
			linearFCTimePeriod,
			lstScenarioCustomerGroups,
			lstScenarioCustomers,
			lstScenarioProducts,
			lstScenarioSKUs,
			manuallyDefinedShare,
			modificationDeviationPercentage,
			periodType,
			previousYearTimePeriod
		} = obj;
		const url = apiUrls.ExportExcelPDF + `countryname=${countryName}&isPdf=${isPdf}`;
		const postBody = {
			scenarioName,
            userid,
            roleName,
            isEdit,
            email,
            displayStickToQuota,
            sentToSAP,
            SentToSAP4PLExport,
            stickToQuota,
            scenarioDatasource,
            customers,
            customerGroups,
            product,
            productGroup,
            criticalityId ,
            scenarioStatus,
            effectiveStartDate,
            effectiveEndDate,
            updatedBy,
			updatedDate,
			countryID,
			customerBreakdown ,
			customerBreakdownType,
			skuBreakdown,
			defaultInitialForecast,
			emailNotification,
			financialFCTimePeriod,
			linearFCTimePeriod,
			lstScenarioCustomerGroups,
			lstScenarioCustomers,
			lstScenarioProducts,
			lstScenarioSKUs,
			manuallyDefinedShare,
			modificationDeviationPercentage,
			periodType,
			previousYearTimePeriod,
		};
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(postBody),
			});
			const res = await response.blob();
			const extension = isPdf ? "pdf" : "xlsx";
			const fileName = `ScenarioCustomer_${scenarioName}.${extension}`
			saveAs(res, fileName);
			return res;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);
export const LocalAlignmentFilter = createAsyncThunk(
	"setup/LocalAlignmentFilter",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const url = apiUrls.Local_DataAlignment;
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = await response.json();
			return jsonData;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);

export function preparemarketShareGraphData(data) {
	let sortedArrayScenarioSKU = orderBy(data, ["scenarioSKU_MS"], ["desc"]);
	let sortedArrayReferenceSKU = orderBy(data, ["referenceSKU_MS"], ["desc"]);
	let sortedArrayExternal = orderBy(data, ["external_MS"], ["desc"]);
	let sortedArrayManual = orderBy(data,[(item)=> parseInt(item.manually_Defined_MS)], ["desc"]);
	let Count = 0
	let Ids = [];
	for(Count ; Count<sortedArrayScenarioSKU.length; Count++){
	  if(sortedArrayScenarioSKU[Count].scenarioSKU_MS == 0) break;
	  Ids.push(sortedArrayScenarioSKU[Count].id);
	  if(Count === 100) break;
	}
	if(Count < 100){
	  for(let i = 0 ; i < sortedArrayReferenceSKU.length; i++){
		if(sortedArrayReferenceSKU[i].referenceSKU_MS == 0) break;
		let idx = Ids.findIndex(p=>p == sortedArrayReferenceSKU[i].id);
		if(idx == -1){
		  Count += 1;
		  Ids.push(sortedArrayReferenceSKU[i].id);
		  if(Count === 100) break;
		}
	  }
	}
	if(Count < 100){
	  for(let i = 0 ; i < sortedArrayExternal.length; i++){
		if(sortedArrayExternal[i].external_MS == 0) break;
		let idx = Ids.findIndex(p=>p == sortedArrayExternal[i].id);
		if(idx == -1){
		  Count += 1;
		  Ids.push(sortedArrayExternal[i].id);
		  if(Count === 100) break;
		}
	  }
	}
	if(Count < 100){
	  for(let i = 0 ; i < sortedArrayManual.length; i++){
		if(sortedArrayManual[i].manually_Defined_MS == 0) break;
		let idx = Ids.findIndex(p=>p == sortedArrayManual[i].id);
		if(idx == -1){
		  Count += 1;
		  Ids.push(sortedArrayManual[i].id);
		  if(Count === 100) break;
		}
	  }
	}
   // if(j > 100) j= 100; //setting max limit to 100 customers
	const filteredData = data.filter((x) => Ids.includes(x.id));
	let entities = [...new Set(filteredData.map((obj) => obj.name))];
	let legends = ['Scenario SKU','Reference SKU','External','Manually Defined'];

	let statuses = {};
	for (let i = 0; i < entities.length; ++i) {
		statuses[entities[i]] = new Array(legends.length).fill(0);
		//if(i == j) break;
	}
																	 
	for (let i = 0; i < filteredData.length; ++i) {
		const obj = filteredData[i];
		const { name } = obj;
		statuses[name][0] = obj.scenarioSKU_MS;
		statuses[name][1] = obj.referenceSKU_MS;
		statuses[name][2] = obj.external_MS;
		statuses[name][3] = obj.manually_Defined_MS;
		//if(i == j) break;
	}
	const preparedData = statuses;
	return preparedData;
}
const editScenarioNewSlice = createSlice({
	name: "editScenarioNew",
	initialState,
	reducers: {
		setState: {
			prepare(stateName, stateValue) {
				return {
					payload: { stateName, stateValue },
				};
			},
			reducer(state, action) {
				const { stateName, stateValue } = action.payload;
				state[stateName] = stateValue;
			}, 
		},
		reset(state, { payload }) {
			if (payload === "selectScenario") {
				state.isLoading= false;
				state.sku_PG_Name= "";
				state.productGroups= [];
				state.selectedPGs= [];
				state.selectedcustomerTypes= [];
				state.selectedCustType= "";
				state.selectedCTCode= "";
				state.selectedCL= "";
				state.selectedCLID= "";
				state.breakDowns= [];
				state.selectedBD= "";
				state.breakDownTypes= [];
				state.selectedBDT= "";
				state.selectedTL= "All";
				state.selectedTLID= 0;
				state.customerName= "";
				state.custsCGs= [];
				state.selectedCustsCGs= [];
				state.selectedDSs= [];
				state.selectedPDS= "";
				state.selectedSKUBDM= "";
				state.selectedScSTQ= "";
				state.selectedPG_SKU_ADSs="";
				state.selectedPG_SKU_ADSsID= "";
				state.DSAData= [];
				state.scDSA= [];
				state.scDSACopy= [];
				state.DSAIdString= "";
				state.DSAIdStringPrev= "";
				state.skuBreakdown= "";
				state.customerBreakdownType= "Scenario SKUs";
				state.customerBreakdown= "Internal 3 months";
				state.MarketShareTimePeriod= "";
				state.PreviousMarketShareTimePeriod= "";
				state.scenarioName= "";
				// api payload for scenario
				state.primaryDataSourceID= "";
				state.minimumQuota= "";
				state.comments= "";
				state.lstScenarioCustomers= "";
				state.lstScenarioCustomerGroups= "";
				state.lstScenarioSKUs= "";
				state.lstScenarioProducts= "";
				state.scenarioDataSourceAlignment= [];
				state.scenarioStatus= "";
				state.editScDetails= null;
				state.message= "";
				state.severity= "";
				state.messageOpen= "";
				state.selectedLinearTrend= state.predictionMethodPeriodList[0]?.name;
				state.selectedRunRate= state.predictionMethodPeriodList[0]?.name;
				state.selectedConsensus= state.predictionMethodPeriodList[0]?.name;
				state.selectedPreviousYear= state.previousYearPeriodList[0]?.name;
				state.selectedDefaultInitialForecast= state.DefaultInitialForecast[1]?.name;
				state.editScDSAData= [];
				state.localForecastAlignment= [];
				state.periodType= "";
				state.emailNotification= false;
				state.email = "";
				state.criticalityId= "";
				state.SafetyMargin=[];
				//state.SafetyMargin= [{type: "Customer Group= safetyMargin: '', typeCode: "CustomerGroup"}],;
				state.selectedReferenceSKU= [];
				state.previousSelectedReferenceSKU= [];
				state.marketShareComparisonList= [];
				state.previousMarketShareComparisonList= [];
				state.selectedRows= [];
				state.marketShareGraphData= [];
				state.previousMarketShareGraphData= [];
				state.manually_defineMSList= [];
				state.quotaDeviationPercentage= 0;
				state.modificationDeviationPercentage= 0;
				state.scenarioExternalDataSource= [];
				state.scenarioExternalDataSourceSKU= [];
				state.refList='';
				state.selectedCCID= 0;
				state.selectedCustCat= "All";
				state.openScenarioPopUp= false;
				state.errorMessage= "";
				state.errorList= [];
				state.createToDate= null;
				state.createFromDate= null;
				state.section_Scenario_Parameteres= false;
				state.section_SKU= false;
				state.section_Customer= false;
				state.section_Datasources= false;
				state.section_Scenario_Settings= false;
				state.activeCustomerOnly=true;
				state.isCustomerChanged = false;
				state.data_after_Submit = null;
			} else if(payload === "refresh"){
				state.isLoading= false;
				state.sku_PG_Name= "";
				state.productGroups= [];
				state.selectedPGs= [];
				state.selectedcustomerTypes= [];
				state.selectedCustType= "";
				state.selectedCTCode= "";
				state.selectedCL= "";
				state.selectedCLID= "";
				state.breakDowns= [];
				state.selectedBD= "";
				state.breakDownTypes= [];
				state.selectedBDT= "";
				state.selectedTL= "All";
				state.selectedTLID= 0;
				state.customerName= "";
				state.custsCGs= [];
				state.selectedCustsCGs= [];
				state.selectedDSs= [];
				state.selectedPDS= "";
				state.selectedSKUBDM= "";
				state.selectedScSTQ= "";
				state.selectedPG_SKU_ADSs="";
				state.selectedPG_SKU_ADSsID= "";
				state.DSAData= [];
				state.scDSA= [];
				state.scDSACopy= [];
				state.DSAIdString= "";
				state.DSAIdStringPrev= "";
				state.skuBreakdown= "";
				state.customerBreakdownType= "Scenario SKUs";
				state.customerBreakdown= "Internal 3 months";
				state.MarketShareTimePeriod= "";
				state.PreviousMarketShareTimePeriod= "";
				state.scenarioName= "";
				// api payload for scenario
				state.primaryDataSourceID= "";
				state.minimumQuota= "";
				state.comments= "";
				state.lstScenarioCustomers= "";
				state.lstScenarioCustomerGroups= "";
				state.lstScenarioSKUs= "";
				state.lstScenarioProducts= "";
				state.scenarioDataSourceAlignment= [];
				state.scenarioStatus= "";
				state.editScName= "";
				state.editScenarioList= [];
				state.editScID= "";
				state.editScDetails= null;
				state.message= "";
				state.severity= "";
				state.messageOpen= "";
				state.selectedLinearTrend= state.predictionMethodPeriodList[0]?.name;
				state.selectedRunRate= state.predictionMethodPeriodList[0]?.name;
				state.selectedConsensus= state.predictionMethodPeriodList[0]?.name;
				state.selectedPreviousYear= state.previousYearPeriodList[0]?.name;
				state.selectedDefaultInitialForecast= state.DefaultInitialForecast[1]?.name;
				state.editScDSAData= [];
				state.localForecastAlignment= [];
				state.periodType= "";
				state.emailNotification= false;
				state.email = "";
				state.criticalityId= "";
				state.SafetyMargin=[];
				//state.SafetyMargin= [{type: "Customer Group= safetyMargin: '', typeCode: "CustomerGroup"}],;
				state.selectedReferenceSKU= [];
				state.previousSelectedReferenceSKU= [];
				state.marketShareComparisonList= [];
				state.previousMarketShareComparisonList= [];
				state.selectedRows= [];
				state.marketShareGraphData= [];
				state.previousMarketShareGraphData= [];
				state.manually_defineMSList= [];
				state.quotaDeviationPercentage= 0;
				state.modificationDeviationPercentage= 0;
				state.scenarioExternalDataSource= [];
				state.scenarioExternalDataSourceSKU= [];
				state.refList='';
				state.selectedCCID= 0;
				state.selectedCustCat= "All";
				state.selectedCountry= "";
				state.countryID= "";
				state.createToDate= null;
				state.createFromDate= null;
				state.openScenarioPopUp= false;
				state.errorMessage= "";
				state.errorList= [];
				state.section_Scenario_Parameteres= false;
				state.section_SKU= false;
				state.section_Customer= false;
				state.section_Datasources= false;
				state.section_Scenario_Settings= false;
				state.isCustomerChanged = false;
				state.search_ScenarioName = "";
				state.search_FromDate = null;
				state.search_ToDate = null;
				state.data_after_Submit = null;
			}
		},
		setScDSA: {
			prepare(scDSAInd, attrIndex, list, isSelected,datasourceid,attributeName) {
				return {
					payload: { scDSAInd, attrIndex, list, isSelected,datasourceid,attributeName },
				};
			},
			reducer(state, action) {
				const { scDSAInd, attrIndex, list, isSelected,datasourceid,attributeName } = action.payload;
				if (isSelected) {
					state.scDSA[scDSAInd].attributes[
						attrIndex
					].selectedAttributeValues = list;
				} else {
					state.scDSA[scDSAInd].attributes[attrIndex].attributeValues =
						list;
				}
				if((datasourceid === 2 && (attributeName ==="Country" || attributeName ==="Panel" ))||
				(datasourceid === 3 && attributeName ==="Country")||
				(datasourceid > 3 && (attributeName ==="Customer Name" || attributeName ==="Customer Number" || attributeName ==="Company" || attributeName ==="Source" || attributeName === "Measure"))
				){
					for(let i = 0 ; i< state.scDSA.length; i++){
						if(state.scDSA[i].dataSourceID === datasourceid){
							if(i !== scDSAInd){
								if (isSelected) {
									state.scDSA[i].attributes[
										attrIndex
									].selectedAttributeValues = list;
								}
								else{
									state.scDSA[i].attributes[attrIndex].attributeValues =
										list;
								}
							}
						}
					}
				}
				if(datasourceid === 2){
					let scDSAData = state.scDSA.find(x => x.dataSourceID === 2 && (x.skuid === state.selectedPG_SKU_ADSsID || x.productGroupID === state.selectedPG_SKU_ADSsID));
					let panel = "";
					let country = "";
					let product = "";
					let strength = "";
					let pack = "";
					if (scDSAData !== undefined && scDSAData !== null) {
						for (let i = 0; i < scDSAData.attributes.length; i++) {
							if (scDSAData.attributes[i].attributeName === "Country") {
								country = scDSAData.attributes[i].selectedAttributeValues.join('|');
							}
							if (scDSAData.attributes[i].attributeName === "Panel") {
								panel = scDSAData.attributes[i].selectedAttributeValues.join('|');
							}
							if (scDSAData.attributes[i].attributeName === "Strength") {
								strength = scDSAData.attributes[i].selectedAttributeValues.join('|');
							}
							if (scDSAData.attributes[i].attributeName === "Product") {
								product = scDSAData.attributes[i].selectedAttributeValues.join('|');
							}
							if (scDSAData.attributes[i].attributeName === "Pack") {
								pack = scDSAData.attributes[i].selectedAttributeValues.join('|');
							}
						}
						let filter = {
							countryid: state.countryID,
							id: state.selectedPG_SKU_ADSsID,
							product: product,
							strength: strength,
							panel: panel,
							country: country,
							pack: pack,
						}
						if (state.midasFilterParameters.id === filter.id) {
							//state.isLoadingEdit = true;
							if (state.midasFilterParameters.countryid !== filter.countryid || state.midasFilterParameters.product !== filter.product || state.midasFilterParameters.strength !== filter.strength || state.midasFilterParameters.country !== filter.country || state.midasFilterParameters.panel !== filter.panel) {
								state.midasFilterParameters = filter;
							}
						}else{
							//state.isLoadingEdit = true;
							state.midasFilterParameters = filter;
						}
					}
				}
				if(datasourceid >= 5){
					let scDSAData = state.scDSA.find(x => x.dataSourceID === datasourceid && (x.skuid === state.selectedPG_SKU_ADSsID || x.productGroupID === state.selectedPG_SKU_ADSsID));
					let customerName = "";
					let customerNumber = "";
					let company = "";
					let source = "";
					let product = "";
					let pack = "";
					let skuNumber = "";
					let skuName = "";
					if (scDSAData !== undefined && scDSAData !== null) {
						for (let i = 0; i < scDSAData.attributes.length; i++) {
							if (scDSAData.attributes[i].attributeName === "Customer Name") {
								customerName = scDSAData.attributes[i].selectedAttributeValues.join('|');
							}
							if (scDSAData.attributes[i].attributeName === "Customer Number") {
								customerNumber = scDSAData.attributes[i].selectedAttributeValues.join('|');
							}
							if (scDSAData.attributes[i].attributeName === "Company") {
								company = scDSAData.attributes[i].selectedAttributeValues.join('|');
							}
							if (scDSAData.attributes[i].attributeName === "Source") {
								source = scDSAData.attributes[i].selectedAttributeValues.join('|');
							}
							if (scDSAData.attributes[i].attributeName === "Product name") {
								product = scDSAData.attributes[i].selectedAttributeValues.join('|');
							}
							if (scDSAData.attributes[i].attributeName === "Pack Name") {
								pack = scDSAData.attributes[i].selectedAttributeValues.join('|');
							}
							if (scDSAData.attributes[i].attributeName === "SKU#") {
								skuNumber = scDSAData.attributes[i].selectedAttributeValues.join('|');
							}
							if (scDSAData.attributes[i].attributeName === "SKU Name") {
								skuName = scDSAData.attributes[i].selectedAttributeValues.join('|');
							}
						}
						let filter = {
							countryid: state.countryID,
							datasourceid : datasourceid,
							id: state.selectedPG_SKU_ADSsID,
							skuName: skuName,
							product: product,
							skuNumber: skuNumber,
							pack: pack,
							company: company,
							source: source,
							customerNumber: customerNumber,
							customerName: customerName
						}
						if (state.localFilterParameters.id === filter.id) {
							if (state.localFilterParameters.countryid !== filter.countryid || 
								state.localFilterParameters.datasourceid !== filter.datasourceid || 
								state.localFilterParameters.skuName !== filter.skuName || 
								state.localFilterParameters.product !== filter.product || 
								state.localFilterParameters.skuNumber !== filter.skuNumber|| 
								state.localFilterParameters.pack !== filter.pack || 
								state.localFilterParameters.company !== filter.company || 
								state.localFilterParameters.source !== filter.source || 
								state.localFilterParameters.customerNumber !== filter.customerNumber|| 
								state.localFilterParameters.customerName !== filter.customerName) {
								state.localFilterParameters = filter;
							}
						}else{
							state.localFilterParameters = filter;
						}
					}
				}
			},
		},
		setScDSAMeasureNumber: {
			prepare(scDSAInd, value) {
				return {
					payload: { scDSAInd, value },
				};
			},
			reducer(state, action) {
				const { scDSAInd, value } = action.payload;
				state.scDSA[scDSAInd].MeasureNumber = value;
				const dataSourceID = state.scDSA[scDSAInd].dataSourceID;
				for(let i = 0 ; i< state.scDSA.length; i++){
					if(state.scDSA[i].dataSourceID === dataSourceID){
						if(i !== scDSAInd){
							state.scDSA[i].MeasureNumber = value;
						}
					}
				}
			},
		},
		setScDSAMeasure: {
			prepare(scDSAInd, list, isSelected) {
				return {
					payload: { scDSAInd, list, isSelected },
				};
			},
			reducer(state, action) {
				const { scDSAInd, list, isSelected } = action.payload;
				if (isSelected) {
					state.scDSA[scDSAInd].selectedMeasure = list;
				} else {
					state.scDSA[scDSAInd].measure = list;
				}
				const dataSourceID = state.scDSA[scDSAInd].dataSourceID;
				for(let i = 0 ; i< state.scDSA.length; i++){
					if(state.scDSA[i].dataSourceID === dataSourceID){
						if(i !== scDSAInd){
							if (isSelected) {
								state.scDSA[i].selectedMeasure = list;
							} else {
								state.scDSA[i].measure = list;
							}
						}
					}
				}
			},
		},
	},

	extraReducers: (builder) => {
        builder
        .addCase(getUserCountriesEdit.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(getUserCountriesEdit.fulfilled, (state, action) => {
            state.isLoadingEdit = false;
            state.countries = action.payload;
        })
        .addCase(getUserCountriesEdit.rejected, (state, action) => {
            state.isLoadingEdit = false;
            console.error("Error from getUserCountriesEdit", action.error.message);
        })

        .addCase(getDataSources.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(getDataSources.fulfilled, (state, action) => {
            state.isLoadingEdit = false;
            state.dataSources = action.payload;
        })
        .addCase(getDataSources.rejected, (state, action) => {
            state.isLoadingEdit = false;
            console.error("Error from getDataSources", action.error.message);   
        })

        .addCase(getScenario.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(getScenario.fulfilled, (state, action) => {
            state.isLoadingEdit = false;
            state.editScenarioList = action.payload;
			if(state.editScenarioList.length === 0){
				state.messageOpen = true;
				state.message = 'No scenarios found for selected criteria.';
				state.severity = "info";
			}
        })
        .addCase(getScenario.rejected, (state, action) => {
            state.isLoadingEdit = false;
            console.error("Error from getScenario", action.error.message);
        })

        .addCase(getScenarioDetails.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(getScenarioDetails.fulfilled, (state, action) => {
            state.isLoadingEdit = false;
            state.editScDetails = action.payload;
        })
        .addCase(getScenarioDetails.rejected, (state, action) => {
            state.isLoadingEdit = false;
            console.error("Error from getScenarioDetails", action.error.message);
        })
		.addCase(ImportExcelEdit.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(ImportExcelEdit.fulfilled, (state, action) => {
			state.messageOpen = true;
			if (typeof (action.payload) == 'string') {
				state.message = action.payload;
				state.severity = "error";
			}
			else{
				let breakdownList = action.payload;
				for(let i=0; i<breakdownList.length; i++){
					if(breakdownList.length !== state.selectedCustsCGs.length){
						state.message = 'Upload failed. Customers or Customer Groups uploaded are not matching with scenario.';
						state.severity = "error";
						state.isLoadingEdit = false;
						return;
					}
					breakdownList[i].scenarioID = state.editScID;
					if(breakdownList[i].customerName !== undefined && breakdownList[i].customerName !== null && breakdownList[i].customerName !== '') {
						let obj = state.selectedCustsCGs.find(x=> x.name === breakdownList[i].customerName && x.type === "C");
						if(obj !== undefined){
							breakdownList[i].customerID = obj.id;
						}
						else{
							let obj1 = state.selectedCustsCGs.find(x=> x.customerName === breakdownList[i].customerName);
							if(obj1 !== undefined){
								breakdownList[i].customerID = obj1.customerID;
							}
						}
					}
					if(breakdownList[i].customerGroupName !== undefined && breakdownList[i].customerGroupName !== null && breakdownList[i].customerGroupName !== '') {
						let obj = state.selectedCustsCGs.find(x=> x.name === breakdownList[i].customerGroupName && x.type === "CG");
						if(obj !== undefined){
							breakdownList[i].customerGroupID = obj.id;
						}
						else{
							let obj1 = state.selectedCustsCGs.find(x=> x.customerGroupName === breakdownList[i].customerGroupName);
							if(obj1 !== undefined){
								breakdownList[i].customerGroupID = obj1.customerGroupID;
							}
						}
					}
					// let obj = state.selectedCustsCGs.find(x=> x.name?x.name:x.customerName === breakdownList[i].customerName);
					// if(obj !== undefined){
					// 	breakdownList[i].customerID = obj.customerID? obj.customerID:obj.id;
					// }
					// else{
					// 	let obj1 = state.selectedCustsCGs.find(x=> x.name?x.name:x.customerGroupName === breakdownList[i].customerGroupName);
					// 	if(obj1 !== undefined){
					// 		breakdownList[i].customerGroupID = obj1.customerGroupID?obj1.customerGroupID:obj1.id;
					// 	}
					// }
					
					if (breakdownList[i].customerID == 0 && breakdownList[i].customerGroupID == 0) {
						state.message = 'Customers or Customer Groups not found in the scenario. Please check the file and try again.';
						state.severity = "error";
						state.isLoadingEdit = false;
						return;
					}
				}
				state.scenarioExternalDataSource = breakdownList;
				state.message = "Customer share data uploaded successfully.";
				state.severity = "success";
			}
            state.isLoadingEdit = false;
        })
        .addCase(ImportExcelEdit.rejected, (state, action) => {
            console.error("Error from ImportExcelEdit", action.error.message);
            state.isLoadingEdit = false;
        })
		.addCase(ImportExcelSKUEdit.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(ImportExcelSKUEdit.fulfilled, (state, action) => {
			state.messageOpen = true;
			if (typeof (action.payload) == 'string') {
				state.message = action.payload;
				state.severity = "error";
			}
			else{
				let breakdownList = action.payload;
				for(let i=0; i<breakdownList.length; i++){
					if(breakdownList.length !== state.selectedPGs.length){
						state.message = 'Upload failed. SKUs or Product Groups uploaded are not matching with scenario.';
						state.severity = "error";
						state.isLoadingEdit = false;
						return;
					}
					breakdownList[i].scenarioID = state.editScID;
					if(breakdownList[i].skuName !== undefined && breakdownList[i].skuName !== null && breakdownList[i].skuName !== '') {
						let obj = state.selectedPGs.find(x=> x.name === breakdownList[i].skuName && x.type ==='P');
						if(obj !== undefined){
							breakdownList[i].skuId = obj.id;
						}
						else{
							let obj1 = state.selectedPGs.find(x=> x.name === breakdownList[i].skuName);
							if(obj1 !== undefined){
								breakdownList[i].skuId = obj1.productID;
							}
						}
					}
					if(breakdownList[i].productGrpName !== undefined && breakdownList[i].productGrpName !== null && breakdownList[i].productGrpName !== '') {
						let obj = state.selectedPGs.find(x=> x.name === breakdownList[i].productGrpName && x.type ==='PG');
						if(obj !== undefined){
							breakdownList[i].productGrpId = obj.id;
						}
						else{
							let obj1 = state.selectedPGs.find(x=> x.productGroupName === breakdownList[i].productGrpName);
							if(obj1 !== undefined){
								breakdownList[i].productGrpId = obj1.productGroupID;
							}
						}
					}
					// let obj = state.selectedPGs.find(x=> x.name === breakdownList[i].skuName);
					// if(obj !== undefined){
					// 	breakdownList[i].skuId = obj.productID?obj.productID:obj.id;
					// }
					// else{
					// 	let obj1 = state.selectedPGs.find(x=> x.name?x.name:x.productGroupName === breakdownList[i].productGrpName);
					// 	if(obj1 !== undefined){
					// 		breakdownList[i].productGrpId = obj1.productGroupID?obj1.productGroupID:obj1.id;
					// 	}
					// }
					if (breakdownList[i].skuId == 0 && breakdownList[i].productGrpId == 0) {
						state.message = 'SKUs or Product Groups not found in the scenario. Please check the file and try again.';
						state.severity = "error";
						state.isLoadingEdit = false;
						return;
					}
				}
				state.scenarioExternalDataSourceSKU = breakdownList;
				state.message = "SKU share data uploaded successfully.";
				state.severity = "success";
			}
            state.isLoadingEdit = false;
        })
        .addCase(ImportExcelSKUEdit.rejected, (state, action) => {
            console.error("Error from ImportExcelSKUEdit", action.error.message);
            state.isLoadingEdit = false;
        })

        .addCase(getScDSAData.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(getScDSAData.fulfilled, (state, action) => {
            state.editScDSAData = action.payload;
            state.isLoadingEdit = false;
        })
        .addCase(getScDSAData.rejected, (state, action) => {
            console.error("Error from getScDSAData", action.error.message);
            state.isLoadingEdit = false;
        })

        .addCase(getAllEnums.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(getAllEnums.fulfilled, (state, action) => {
            state.isLoadingEdit = false;
            state.periodTypes = action.payload.PeriodType;
			state.predictionMethodPeriodList = action.payload.PredictionMethodPeriod;
			state.previousYearPeriodList = action.payload.PreviousYearTimePeriod;
			state.selectedLinearTrend = state.predictionMethodPeriodList[0].name;
			state.selectedRunRate = state.predictionMethodPeriodList[0].name;
			state.selectedConsensus = state.predictionMethodPeriodList[0].name;
			state.selectedPreviousYear = state.previousYearPeriodList[0].name;
			state.DefaultInitialForecast = action.payload.DefaultInitialForecast;
			state.selectedDefaultInitialForecast = state.DefaultInitialForecast[1].name;
        })
        .addCase(getAllEnums.rejected, (state, action) => {
            state.isLoadingEdit = false;
            console.error("Error from getAllEnums", action.error.message);
        })

		.addCase(getCriticalityList.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(getCriticalityList.fulfilled, (state, action) => {
            state.criticalityList = action.payload;
            state.isLoadingEdit = false;
        })
        .addCase(getCriticalityList.rejected, (state, action) => {
            console.error("Error from getCriticalityList", action.error.message);
            state.isLoadingEdit = false;
        })


        .addCase(getProductGroup.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(getProductGroup.fulfilled, (state, action) => {
            state.isLoadingEdit = false;
            let filteredList = action.payload;
            if (state.selectedSKUCategory === "Individual SKU") {
                filteredList = filteredList.filter(
                    (product) => product.type === "P"
                );
            } else if (state.selectedSKUCategory === "Product Group") {
                filteredList = filteredList.filter(
                    (product) => product.type === "PG"
                );
            }
			if(state.selectedPGs.length > 0){
				for(let i = 0; i<state.selectedPGs.length; i++){
					let cid;
					let type;
					if(state.selectedPGs[i].type === "P"){
						cid = state.selectedPGs[i].id;
						type = "P";
					}
					else if(state.selectedPGs[i].type === "PG"){
						cid = state.selectedPGs[i].id;
						type = "PG";
					}
					else if(state.selectedPGs[i].hasOwnProperty("productID")){
						cid = state.selectedPGs[i].productID;
						type = "P";
					}
					else if(state.selectedPGs[i].hasOwnProperty("productGroupID")){
						cid = state.selectedPGs[i].productGroupID;
						type = "PG";
					}
					let idx = filteredList.findIndex((product) => product.id === cid && product.type === type);
					if(idx > -1){
						filteredList.splice(idx, 1);
					}
				}
			}
			if(state.selectedReferenceSKU?.length > 0){
				for(let i = 0; i<state.selectedReferenceSKU.length; i++){
					let cid;
					let type;
					cid = state.selectedReferenceSKU[i].id;
					type = "P";
					let idxs = filteredList.findIndex((product) => product.id === cid && product.type === type);
					if(idxs > -1){
						filteredList.splice(idxs, 1);
					}
				}
			}
			if(state.selectedReferenceSKU === undefined || state.selectedReferenceSKU.length === 0){
				let list = state.refList?.split(',');
				if(list.length > 0){
					for(let i = 0; i<list.length; i++){
						let cid;
						let type;
						cid = Number(list[i]);
						type = "P";
						let idxs = filteredList.findIndex((product) => product.id === cid && product.type === type);
						if(idxs > -1){
							filteredList.splice(idxs, 1);
						}
					}
				}
			}
			state.productGroups  = filteredList;
			if(state.productGroups.length === 0){
				state.messageOpen = true;
				state.message = "No SKU/ product group found for given search criteria";
				state.severity = "info";
			}

        })
        .addCase(getProductGroup.rejected, (state, action) => {
            state.isLoadingEdit = false;
            console.error("Error from getProductGroup", action.error.message);
        })
		.addCase(getProductGroupForMS.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(getProductGroupForMS.fulfilled, (state, action) => {
            let filteredList = action.payload;
			filteredList = filteredList.filter(
				(product) => product.type === "P"
			);
            if(state.selectedPGs.length > 0){
				for(let i = 0; i<state.selectedPGs.length; i++){
					let cid;
					let type;
					if(state.selectedPGs[i].type === "P"){
						cid = state.selectedPGs[i].id;
						type = "P";
					}
					else if(state.selectedPGs[i].hasOwnProperty("productID")){
						cid = state.selectedPGs[i].productID;
						type = "P";
					}
					let idx = filteredList.findIndex((product) => product.id === cid && product.type === type);
					if(idx > -1){
						filteredList.splice(idx, 1);
					}
				}
			}
			if(state.selectedReferenceSKU === undefined || state.selectedReferenceSKU.length <= 0){
				let referenceList = [];
				let list = state.refList?.split(',').map(Number);
				if(list.length > 0){
					referenceList = filteredList.filter(item => list.includes(Number(item.id)))
				}
				state.selectedReferenceSKU = referenceList;
			}
			state.productGroupsForMS  = filteredList.map((obj) => {
				return { id: obj.id, name: obj.name};
			  });
            state.isLoadingEdit = false;
        })
        .addCase(getProductGroupForMS.rejected, (state, action) => {
            state.isLoadingEdit = false;
            console.error("Error from getProductGroupForMS", action.error.message);
        })


        .addCase(getCustsAndCGs.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(getCustsAndCGs.fulfilled, (state, action) => {
			if(action.payload.length === 0){
				state.messageOpen = true;
				state.message = "No customer/ cusomer groups found for given search criteria";
				state.severity = "info";
			}
            state.isLoadingEdit = false;
			let customerList = action.payload;
			if(state.selectedCustsCGs.length > 0){
				for(let i = 0; i<state.selectedCustsCGs.length; i++){
					let cid;
					let type;
					if(state.selectedCustsCGs[i].type === "C"){
						cid = state.selectedCustsCGs[i].id;
						type = "C";
					}
					else if(state.selectedCustsCGs[i].type === "CG"){
						cid = state.selectedCustsCGs[i].id;
						type = "CG";
					}
					else if(state.selectedCustsCGs[i].hasOwnProperty("customerID")){
						cid = state.selectedCustsCGs[i].customerID;
						type = "C";
					}
					else if(state.selectedCustsCGs[i].hasOwnProperty("customerGroupID")){
						cid = state.selectedCustsCGs[i].customerGroupID;
						type = "CG";
					}
					let idx = customerList.findIndex((cust) => cust.id === cid && cust.type === type);
					if(idx > -1){
						customerList.splice(idx, 1);
					}
				}
				state.custsCGs = customerList;
			}
			else{
				state.custsCGs = customerList;
			}
        })
        .addCase(getCustsAndCGs.rejected, (state, action) => {
            state.isLoadingEdit = false;
            console.error("Error from getCustsAndCGs", action.error.message);
        })

		.addCase(getCustGrpRef.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(getCustGrpRef.fulfilled, (state, action) => {
			state.isLoadingEdit = false;
            state.customerTypes = action.payload.customerTypes;
			state.selectedCTCode = action.payload.customerTypes[0].customerTypeCode;
			state.selectedCustType = action.payload.customerTypes[0].customerTypeName;
            state.customerLevels = action.payload.customerLevels;
			const idx = state.customerLevels.findIndex((custLevel) => custLevel.customerLevelID === "SH");
			state.selectedCL = state.customerLevels[idx].customerLevel
			state.selectedCLID = state.customerLevels[idx].customerLevelID;
			let custGrpRef = action.payload.scenarioSafetyMarginType;
        })
        .addCase(getCustGrpRef.rejected, (state, action) => {
            state.isLoadingEdit = false;
            console.error("Error from getCustGrpRef", action.error.message);
        })

		.addCase(getTrustLevel.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(getTrustLevel.fulfilled, (state, action) => {
            state.isLoadingEdit = false;
            state.trustLevels = action.payload;
        })
        .addCase(getTrustLevel.rejected, (state, action) => {
            state.isLoadingEdit = false;
            console.error("Error from getTrustLevel", action.error.message);
        })


		.addCase(getDSAData.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(getDSAData.fulfilled, (state, action) => {
            state.isLoadingEdit = false;
            state.DSAData = action.payload;
        })
        .addCase(getDSAData.rejected, (state, action) => {
            state.isLoadingEdit = false;
            console.error("Error from getDSAData", action.error.message);
        })
		.addCase(localForecastDataAlignmentCheck.pending, (state, action) => {
            state.isLoadingEdit = true;
        }) 
        .addCase(localForecastDataAlignmentCheck.fulfilled, (state, action) => {
            state.localForecastAlignment = action.payload;
            state.isLoadingEdit = false;
        })
        .addCase(localForecastDataAlignmentCheck.rejected, (state, action) => {
            console.error("Error from localForecastDataAlignmentCheck", action.error.message);
            state.isLoadingEdit = false;
        })
		// .addCase(MidasAlignmentFilter.pending, (state, action) => {
        //     state.isLoading = true;
        // }) 
        // .addCase(MidasAlignmentFilter.fulfilled, (state, action) => {
        //     state.midasFilter = action.payload;
        //     state.isLoadingEdit = false;
        // })
        // .addCase(MidasAlignmentFilter.rejected, (state, action) => {
        //     console.error("Error from MidasAlignmentFilter", action.error.message);
        //     state.isLoadingEdit = false;
        // })
		.addCase(MidasAlignmentFilter.pending, (state, action) => {
			state.isLoadingAlignment = true;
		}) 
		.addCase(MidasAlignmentFilter.fulfilled, (state, action) => {
			state.MidasFilter = action.payload;
			let saCopy = state.scDSA.find(x => x.dataSourceID === 2 && (x.skuid === state.selectedPG_SKU_ADSsID || x.productGroupID === state.selectedPG_SKU_ADSsID));
			if (saCopy !== undefined) {
				for (let i = 0; i < saCopy.attributes.length; i++) {
					// if (saCopy.attributes[i].attributeName === "Country") {
					// 	saCopy.attributes[i].attributeValues = state.MidasFilter.country;
					// }
					if (saCopy.attributes[i].attributeName === "Product") {
						saCopy.attributes[i].attributeValues = state.MidasFilter.product;
					}
					if (saCopy.attributes[i].attributeName === "Strength") {
						saCopy.attributes[i].attributeValues = state.MidasFilter.strength;
					}
					if (saCopy.attributes[i].attributeName === "Panel") {
						saCopy.attributes[i].attributeValues = state.MidasFilter.panel;
					}
					if (saCopy.attributes[i].attributeName === "Pack") {
						saCopy.attributes[i].attributeValues = state.MidasFilter.pack;
					}
				}
			}
			
			state.isLoadingAlignment = false;
		})
		.addCase(MidasAlignmentFilter.rejected, (state, action) => {
			console.error("Error from MidasAlignmentFilter", action.error.message);
			state.isLoadingAlignment = false;
		})
		.addCase(LocalAlignmentFilter.pending, (state, action) => {
			state.isLoadingAlignment = true;
		}) 
		.addCase(LocalAlignmentFilter.fulfilled, (state, action) => {
		state.LocalFilter = action.payload;
		let saCopy = state.scDSA.find(x => x.dataSourceID === state.LocalFilter.datasourceId && (x.skuid === state.selectedPG_SKU_ADSsID || x.productGroupID === state.selectedPG_SKU_ADSsID));
		if (saCopy !== undefined) {
			for (let i = 0; i < saCopy.attributes.length; i++) {
				if (saCopy.attributes[i].attributeName === "Customer Name") {
					saCopy.attributes[i].attributeValues = state.LocalFilter.customerName;
				}
				if (saCopy.attributes[i].attributeName === "Customer Number") {
					saCopy.attributes[i].attributeValues = state.LocalFilter.customerNumber;
				}
				if (saCopy.attributes[i].attributeName === "Company") {
					saCopy.attributes[i].attributeValues = state.LocalFilter.company;
				}
				if (saCopy.attributes[i].attributeName === "Source") {
					saCopy.attributes[i].attributeValues = state.LocalFilter.source;
				}
				if (saCopy.attributes[i].attributeName === "Product name") {
					saCopy.attributes[i].attributeValues = state.LocalFilter.product;
				}
				if (saCopy.attributes[i].attributeName === "Pack Name") {
					saCopy.attributes[i].attributeValues = state.LocalFilter.pack;
				}
				if (saCopy.attributes[i].attributeName === "SKU#") {
					saCopy.attributes[i].attributeValues = state.LocalFilter.skuNumber;
				}
				if (saCopy.attributes[i].attributeName === "SKU Name") {
					saCopy.attributes[i].attributeValues = state.LocalFilter.skuName;
				}
			}
		}
		
		state.isLoadingAlignment = false;
		})
		.addCase(LocalAlignmentFilter.rejected, (state, action) => {
			console.error("Error from LocalAlignmentFilter", action.error.message);
			state.isLoadingAlignment = false;
		})
		.addCase(getScSTQ.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(getScSTQ.fulfilled, (state, action) => {
            state.isLoadingEdit = false;
            state.scenarioSTQ = action.payload;
        })
        .addCase(getScSTQ.rejected, (state, action) => {
            state.isLoadingEdit = false;
            console.error("Error from getScSTQ", action.error.message);
        })
		.addCase(MarketShareComparison.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
		.addCase(MarketShareComparison.fulfilled, (state, action) => {
			state.marketShareComparisonList = action.payload;
			if(state.scenarioExternalDataSource!= undefined && state.scenarioExternalDataSource != null && state.scenarioExternalDataSource.length>0){
				let MSShare = JSON.parse(JSON.stringify(state.marketShareComparisonList));
				for(let i = 0 ;i<state.marketShareComparisonList.length ; i++){
				  let res = state.scenarioExternalDataSource.find(p=>p['customerID']== state.marketShareComparisonList[i].id || p['customerGroupID']== state.marketShareComparisonList[i].id);
				  if(res != undefined){
					MSShare[i].external_MS = res.share * 100;
				  }
				}
				state.marketShareComparisonList = MSShare;
			}
			if(state.manually_defineMSList!= undefined && state.manually_defineMSList != null && state.manually_defineMSList.length>0){
				let MarSShare = JSON.parse(JSON.stringify(state.marketShareComparisonList));
				for(let i = 0 ;i<state.marketShareComparisonList.length ; i++){
				  let md = state.manually_defineMSList.find(p=>p['id']== state.marketShareComparisonList[i].id && p['type']== state.marketShareComparisonList[i].type);
				  if(md != undefined){
					MarSShare[i].manually_Defined_MS = md.share;
				  }
				}
				state.marketShareComparisonList = MarSShare;
			}
			state.marketShareGraphData =
			preparemarketShareGraphData(
				state.marketShareComparisonList
			);

			// let footer =     {
			// 	"name": "Total",
			// 	"id": -1,
			// 	"number": "",
			// 	"type": "",
			// 	"scenarioSKU_Volume": action.payload.reduce((a, b) => a + b.scenarioSKU_Volume, 0),
			// 	"scenarioSKU_MS":  action.payload.reduce((a, b) => a + b.scenarioSKU_MS, 0),
			// 	"referenceSKU_Volume": action.payload.reduce((a, b) => a + b.referenceSKU_Volume, 0),
			// 	"referenceSKU_MS": action.payload.reduce((a, b) => a + b.referenceSKU_MS, 0),
			// 	"external_MS":  action.payload.reduce((a, b) => a + b.external_MS, 0),
			// 	"external_Fix_MS":  action.payload.reduce((a, b) => a + b.external_Fix_MS, 0),
			// 	"manually_Defined_MS":  action.payload.reduce((a, b) => a + b.manually_Defined_MS, 0),
			// 	isRowPinned: true
			// }
			// let header =     {
			// 	"name": "",
			// 	"id": 0,
			// 	"number": "",
			// 	"type": "",
			// 	"scenarioSKU_Volume": 'Volume',
			// 	"scenarioSKU_MS": 'MS%',
			// 	"referenceSKU_Volume": 'Volume',
			// 	"referenceSKU_MS": 'MS%',
			// 	"external_MS": 'MS%',
			// 	"external_Fix_MS": 'MS%',
			// 	"manually_Defined_MS": undefined,
			// 	isRowPinned: true
			// }
			//state.marketShareComparisonList.unshift(header);
			//state.marketShareComparisonList.push(footer);
			state.isLoadingEdit = false;
        })
        .addCase(MarketShareComparison.rejected, (state, action) => {
            console.error("Error from MarketShareComparison", action.error.message);
            state.isLoadingEdit = false;
        })
		.addCase(submitScenario.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(submitScenario.fulfilled, (state, action) => {
            state.isLoadingEdit = false;
			if (typeof (action.payload) == 'string') {
				state.messageOpen = true;
				state.message = action.payload;
				state.severity = "error";
			} else if(action.payload.message && action.payload.message != ''){
				// state.openScenarioPopUp = true;
				// state.errorMessage = action.payload.message;
				// if(action.payload.errorList.length == 0){
				// 	state.errorList = [];
				// }else{
				// 	state.errorList = action.payload.errorList;
				// }
				state.messageOpen = true;
				state.message = action.payload.message;
				state.severity = "error";
			}
			else{
				state.messageOpen = true;
				state.message = "Scenario Submitted Successfully.";
				state.severity = "success";
			}
			if(action.payload.errors == "Customers"){
				state.section_Customer = true;
			}else if(action.payload.errors == "Packs"){
				state.section_SKU = true;
			}else if(action.payload.errors == "Both"){
				state.section_Customer = true;
				state.section_SKU = true;
			}
        })
        .addCase(submitScenario.rejected, (state, action) => {
            state.isLoadingEdit = false;
            console.error("Error from submitScenario", action.error.message);
        })

        .addCase(saveScenario.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(saveScenario.fulfilled, (state, action) => {
            state.isLoadingEdit = false;
			if (typeof (action.payload) == 'string') {
				state.message = action.payload;
				state.severity = "error";
			}
			else{
				state.message = "Scenario Saved Successfully";
				state.severity = "success";
			}
            state.messageOpen = true;
        })
        .addCase(saveScenario.rejected, (state, action) => {
            state.isLoadingEdit = false;
            console.error("Error from saveScenario", action.error.message);
        })

        .addCase(verifyScenario.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(verifyScenario.fulfilled, (state, action) => {
			state.isLoadingEdit = false;
            if (action.payload.toString() == "" || action.payload.toString().includes('Scenario is valid')) {
				state.messageOpen = true;
				state.message = action.payload;
				state.severity = "success";
			} else if(action.payload.message && action.payload.message != ''){
				// state.openScenarioPopUp = true;
				// state.errorMessage = action.payload.message;
				// if(action.payload.errorList.length == 0){
				// 	state.errorList = [];
				// }else{
				// 	state.errorList = action.payload.errorList;
				// }
				state.messageOpen = true;
				state.message = action.payload.message;
				state.severity = "error";
			}
			else{
				state.messageOpen = true;
				state.message = action.payload;
				state.severity = "error";
			}
			if(action.payload.errors == "Customers"){
				state.section_Customer = true;
			}else if(action.payload.errors == "Packs"){
				state.section_SKU = true;
			}else if(action.payload.errors == "Both"){
				state.section_Customer = true;
				state.section_SKU = true;
			}
        })
        .addCase(verifyScenario.rejected, (state, action) => {
            state.isLoadingEdit = false;
            console.error("Error from verifyScenario", action.error.message);
        }).addCase(exportTemplate_DataEdit.pending, (state, action) => {
            state.isLoading = true;
        }) 
        .addCase(exportTemplate_DataEdit.fulfilled, (state, action) => {
            state.isLoading = false;
        })
        .addCase(exportTemplate_DataEdit.rejected, (state, action) => {
            console.error("Error from exportTemplate_DataEdit", action.error.message);
            state.isLoading = false;
        }).addCase(exportTemplate_DataSKUEdit.pending, (state, action) => {
            state.isLoading = true;
        }) 
        .addCase(exportTemplate_DataSKUEdit.fulfilled, (state, action) => {
            state.isLoading = false;
        })
        .addCase(exportTemplate_DataSKUEdit.rejected, (state, action) => {
            console.error("Error from exportTemplate_DataSKUEdit", action.error.message);
            state.isLoading = false;
        })

        .addCase(cloneScenario.pending, (state, action) => {
            state.isLoadingEdit = true;
        })
        .addCase(cloneScenario.fulfilled, (state, action) => {
            state.isLoadingEdit = false;
			if (typeof (action.payload) == 'string') {
				state.message = action.payload;
				state.severity = "error";
			}
			else{
				state.message = "Scenario Cloned Successfully";
				state.severity = "success";
			}
            state.messageOpen = true;
        })
        .addCase(cloneScenario.rejected, (state, action) => {
            state.isLoadingEdit = false;
            console.error("Error from cloneScenario", action.error.message);
        })
	},
});

export const { setState,reset, setScDSA, setScDSAMeasureNumber, setScDSAMeasure } =
	editScenarioNewSlice.actions;

export default editScenarioNewSlice.reducer;
